$('.product__media-list').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    prevArrow:"<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0835/9995/0165/files/left_1.svg?v=1720431285L'>",
    nextArrow:"<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0835/9995/0165/files/left.svg?v=1720431285L'>",
    asNavFor: '.thumbnail-list'
    });
$('.thumbnail-list').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    infinite:false,
    asNavFor: '.product__media-list',
    focusOnSelect: true,
    arrows: false,
    responsive: [
        {
          breakpoint: 749,
          settings: {
            vertical: false,
               arrows: false,
          }
        },
      ]
});

// $(".product__media-list").slick({
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   arrows: false,
//   fade: true,
//   infinite: false,
//   useTransform: true,
//   speed: 400,
//   cssEase: "cubic-bezier(0.77, 0, 0.18, 1)",
// });

// $(".thumbnail-list")
//   .on("init", function (event, slick) {
//     $(".thumbnail-list .slick-slide.slick-current").addClass("is-active");
//   })
//   .slick({
//     slidesToShow: 5,
//     slidesToScroll: 1,
//     dots: false,
//     focusOnSelect: false,
//     infinite: false,
//     vertical: true,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 4,
//           slidesToScroll: 1,
//         },
//       },
//     ],
//   });

// $(".product__media-list").on(
//   "afterChange",
//   function (event, slick, currentSlide) {
//     $(".thumbnail-list").slick("slickGoTo", currentSlide);
//     var currrentNavSlideElem ='.thumbnail-list .slick-slide[data-slick-index="' + currentSlide + '"]';
//     $(".thumbnail-list .slick-slide.is-active").removeClass("is-active");
//     $(currrentNavSlideElem).addClass("is-active");
//   }
// );

// $(".thumbnail-list").on("click", ".slick-slide", function (event) {
//   event.preventDefault();
//   var goToSingleSlide = $(this).data("slick-index");
//   $(".product__media-list").slick("slickGoTo", goToSingleSlide);
// });

$(".ingredients-all-data").click(function (e) {
  $(this)
    .toggleClass("active")
    .next(".paragraph-text")
    .slideToggle()
    .closest(".ingredients-all-data_wrapper")
    .siblings(".ingredients-all-data_wrapper")
    .find(".ingredients-all-data")
    .removeClass("active")
    .next(".paragraph-text")
    .slideUp();
});
